// extracted by mini-css-extract-plugin
export default {"reviewWeddingVendorsContainer":"reviewWeddingVendorsContainer--mp-aCdpA"};